import { defineCustomElement, h, provide } from 'vue'
import { createPinia, setActivePinia } from 'pinia'
import App from './App.vue'

const pinia = createPinia()

const ClickstreamElement = defineCustomElement({
    props: {
        crossdomainid: String,
        leveto_source: String,
        leveto_medium: String
    },

    render(props) {
        return h(App, {
                crossdomainid: props.crossdomainid || process.env.VUE_APP_DEFAULT_CROSSDOMAINID || '',
                leveto_source: props.leveto_source || process.env.VUE_APP_DEFAULT_LEVETO_SOURCE || 'VF',
                leveto_medium: props.leveto_medium || process.env.VUE_APP_DEFAULT_LEVETO_MEDIUM || 'XX',
        })
    },

    // Vue sammelt durch 'customElement: true' nun alle Styles aus App.vue
    // (und den Kindkomponenten) und übergibt sie hier als echten Text.
    styles: App.styles,

    setup() {
        setActivePinia(pinia)
        provide(Symbol.for('pinia'), pinia)
        return {}
    }
})

if (!customElements.get('app-ves-clickstream-pv')) {
    customElements.define('app-ves-clickstream-pv', ClickstreamElement)
}